<template>
  <div class="fixed-bottom" >
    <router-link to="/dashboard" class="home">
      <img src="@/assets/img/footer-menu/home.png"
           :class="getRoute() === 'dashboard' ? 'link-active' : ''"
           alt="dashboard">
    </router-link>
    <div class="footer-menu">
      <div class="left-menu">
        <router-link to="/leaderboard"
                     class="d-flex flex-column justify-content-center align-items-center footer-link-left"
                     :style="getRoute() !== 'leaderboard' ? {'color': '#BDBDBD'} : {'color': '#3EAAFF'}">
          <i class="fa fa-star"></i>
          <div class="footer-link-title">{{ $t('LEADERBOARD') }}</div>
        </router-link>
        <router-link to="/store"
                     class="d-flex flex-column justify-content-center align-items-center footer-link-left"
                     :style="getRoute() !== 'store' ? {'color': '#BDBDBD'} : {'color': '#3EAAFF'}">
          <i class="fa fa-store"></i>
          <div class="footer-link-title">{{ $t('STORE')}}</div>
        </router-link>
      </div>
      <div class="right-menu">
        <router-link to="/friends"
                     class="d-flex flex-column justify-content-center align-items-center footer-link-right"
                     :style="getRoute() !== 'friends' ? {'color': '#BDBDBD'} : {'color': '#3EAAFF'}">
          <i class="fa fa-user-friends"></i>
          <div class="footer-link-title">{{ $t('FRIENDS')}}</div>

        </router-link>
        <router-link to="/notifications"
                     class="d-flex flex-column justify-content-center align-items-center footer-link-right"
                     :style="getRoute() !== 'notifications' ? {'color': '#BDBDBD'} : {'color': '#3EAAFF'}">
          <i class="fa fa-bell"></i>
          <div class="footer-link-title">{{ $t('NOTIFICATIONS') }}</div>
        </router-link>
      </div>


    </div>
  </div>
</template>

<script>

export default {
  name: "DashboardFooterMenu",
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
  }
}
</script>

<style scoped>

</style>
